import React from 'react'

const ForumIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="forumGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(180, 160, 200, 1)" />
          <stop offset="100%" stopColor="rgba(140, 120, 160, 1)" />
        </linearGradient>
        <filter id="forumGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Building base */}
      <rect 
        x="4" 
        y="8" 
        width="16" 
        height="14" 
        fill="url(#forumGradient)"
        filter="url(#forumGlow)"
      />
      
      {/* Roof */}
      <path 
        d="M2 8l10-6 10 6H2z"
        fill="url(#forumGradient)"
        filter="url(#forumGlow)"
      />
      
      {/* Columns */}
      <rect x="7" y="11" width="2" height="11" fill="rgba(255, 255, 255, 0.6)"/>
      <rect x="11" y="11" width="2" height="11" fill="rgba(255, 255, 255, 0.6)"/>
      <rect x="15" y="11" width="2" height="11" fill="rgba(255, 255, 255, 0.6)"/>
      
      {/* Door */}
      <rect 
        x="9" 
        y="16" 
        width="6" 
        height="6" 
        fill="rgba(80, 60, 100, 0.8)"
      />
    </svg>
  )
}

export default ForumIcon
